import React from 'react';
import { ObjectSchema } from 'yup';

import { FieldsListQuery_category_fields as FieldT } from '../../../../types/api';
import { GroupT } from '../types';

import Field from './Field';
import FieldGroup from './FieldGroup';

interface Props {
  fieldDefinition: GroupT | FieldT;
  validationSchema: ObjectSchema<object>;
  groupDirection?: 'row' | 'column';
}

export default function FieldDefinition({
  fieldDefinition,
  groupDirection,
  validationSchema,
}: Props) {
  if (fieldDefinition.inputType !== 'GROUP') {
    return (
      <Field
        field={fieldDefinition}
        key={fieldDefinition.id}
        validationSchema={validationSchema as ObjectSchema<object>}
      />
    );
  }

  return (
    <FieldGroup
      direction={groupDirection}
      group={fieldDefinition}
      key={fieldDefinition.id}
      validationSchema={validationSchema as ObjectSchema<object>}
    />
  );
}
